import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "galeri";
var galeriService = {
    galeriYukle(resimList) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                resimList: resimList,
                methodName: "galeriYukle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    galeriList() {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                methodName: "galeriList"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    galeriKaldir(resimId) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                resimId: resimId,
                methodName: "galeriKaldir"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriTanimlama(baslik) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                baslik: baslik,
                methodName: "kategoriTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriList(durum) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                durum: durum,
                methodName: "kategoriList"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriDetay(gkategoriId) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                gkategoriId: gkategoriId,
                methodName: "kategoriDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriDurumGuncelle(gkategoriId,durum) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                gkategoriId: gkategoriId,
                durum: durum,
                methodName: "kategoriDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriGuncelle(gkategoriId,baslik) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                gkategoriId: gkategoriId,
                baslik: baslik,
                methodName: "kategoriGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

}

export default galeriService

